module.exports = "https://cdn.realtymogul.com/static/media/RP_belair.eb67af1e.jpg";